const _excluded = ["id", "text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button, Callout } from 'seagull';
import { getInvoiceQboActions, getInvoiceQboInfoStatus, makeMapContactsAction, makeMapServicesAction, makeRetrySyncAction, makeSyncAction } from "../../business-logic/invoiceQboLogic";
import { useSyncInvoice } from "../../hooks/invoice/useSyncInvoice";
import { useOpenMapServicesModalFromInvoice } from "../Integrations/QBO/MapServicesModal/useOpenMapServicesModalFromInvoice";
import { useOpenMapContactsModalFromInvoice } from "../Integrations/QBO/MapContactsModal/useOpenMapContactsModalFromInvoice";
import { qboIconMap } from "../Integrations/QBO/qboIconMap";
import { getCalloutInfo } from "./FullPageInvoice.utils";
import { invoiceModel } from "../../models";
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
export default function FullPageInvoiceQboSection(props) {
  var _invoiceModel$integra;
  const {
    invoice,
    integratedInvoice,
    reloadInvoice
  } = props;
  const {
    USE_INVOICE_VIEWS = false
  } = useFeatureFlags();
  const openMapServicesModal = useOpenMapServicesModalFromInvoice(invoice, integratedInvoice, reloadInvoice);
  const openMapContactsModal = useOpenMapContactsModalFromInvoice(invoice, integratedInvoice, reloadInvoice);
  const {
    isSyncing,
    syncInvoice
  } = useSyncInvoice(invoice, reloadInvoice);
  const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
  const status = getInvoiceQboInfoStatus((_invoiceModel$integra = invoiceModel.integration(invoice)) === null || _invoiceModel$integra === void 0 ? void 0 : _invoiceModel$integra.status);
  const info = isLinkedToQbo ? getCalloutInfo(USE_INVOICE_VIEWS ? integratedInvoice === null || integratedInvoice === void 0 ? void 0 : integratedInvoice.integration : invoice.integration) : null;
  const actions = isLinkedToQbo ? getInvoiceQboActions({
    integration: USE_INVOICE_VIEWS ? integratedInvoice.integration : invoice.integration,
    syncAction: makeSyncAction(isSyncing, syncInvoice),
    retrySyncAction: makeRetrySyncAction(isSyncing, syncInvoice),
    mapContactsAction: makeMapContactsAction(openMapContactsModal),
    mapServicesAction: makeMapServicesAction(openMapServicesModal)
  }) : [];
  return info ? /*#__PURE__*/React.createElement(Callout, {
    intent: info.intent,
    icon: qboIconMap[status],
    "data-testid": "fpi-".concat(info.id),
    withAction: !!(actions !== null && actions !== void 0 && actions.length) && /*#__PURE__*/React.createElement(React.Fragment, null, actions.map(_ref => {
      let {
          id,
          text
        } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/React.createElement(Button, _extends({
        key: id,
        "data-testid": id,
        skin: "primaryOutline"
      }, rest), text);
    }))
  }, info.text) : null;
}